import type {TestOccurrenceId} from '../../../../../types'
import {stringifyId} from '../../../../../types'
import {UserProperties} from '../../../../../utils/userProperties'
import ContentPanel from '../../../../common/ContentPanel/ContentPanel'
import Icon from '../../../../common/Icon/Icon'
import MuteDetails from '../../../../common/Mutes/MuteDetails'
import {getTestOccurrenceCurrentlyMutes} from '../../../../packages/Tests/Tests.selectors'

import styles from './MutesPanel.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  testOccurrenceId: TestOccurrenceId
  seqKey?: string
  seqOff?: boolean
}

function MutesPanel({testOccurrenceId}: Props) {
  const currentlyMutes = useAppSelector(state =>
    getTestOccurrenceCurrentlyMutes(state, testOccurrenceId),
  )

  return currentlyMutes.length > 0 ? (
    <ContentPanel
      panelType={UserProperties.EXPAND_TEST_HISTORY_MUTES_SECTION}
      heading={
        <div className={styles.heading}>
          <Icon className={styles.headingIcon} name="mute" aria-label="mute" title="" />
          <span>{'Currently Muted'}</span>
        </div>
      }
      content={
        <>
          {currentlyMutes.map(mute => (
            <div key={stringifyId(mute.id)} className={styles.muteDetails}>
              <MuteDetails mute={mute} currentlyMuted />
            </div>
          ))}
        </>
      }
      withBorder={false}
    />
  ) : null
}

export default MutesPanel
